import { GetterTree } from 'vuex';
import { RootState, MRState } from '../../types';

export const getters: GetterTree<MRState, RootState> = {
  getErrors: (state) => {
    console.log(state);
    return [];
  }
};